



























































































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeClient from '@/stores/modules/client';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import TableCell from '@/components/Paginate/TableCell.vue';

import {
	DxDataGrid,
	DxColumn,
	DxEditing,
	DxFilterRow,
	DxHeaderFilter,
	DxGroupPanel,
	DxGrouping,
	DxScrolling,
	DxSummary,
	DxLookup,
	DxTotalItem,
	DxGroupItem,
	DxMasterDetail,
	DxStringLengthRule,
	DxRequiredRule,
	DxRangeRule,
	DxValueFormat,
	DxPaging,
	DxPager,
} from 'devextreme-vue/data-grid';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import storeToken from "@/stores/modules/token";
import {Stored} from "vue-stored-prop-decorator";
import {Client, Token} from "@/models";
import CrudClientEditDialog from "@/components/Crud/Client/EditDialog.vue";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";

@Component({
	components: {
		CrudList, TableHead, TableCell,
		DxDataGrid, DxColumn, DxEditing,
		DxFilterRow, DxHeaderFilter, DxGroupPanel,
		DxGrouping, DxScrolling, DxSummary,
		DxLookup, DxTotalItem, DxGroupItem,
		DxMasterDetail, DxStringLengthRule, DxRangeRule,
		DxRequiredRule, DxValueFormat, DxPaging,
		DxPager, DxCheckBox, CrudClientEditDialog,
		CrudDeleteDialog,
	}
})
export default class CrudClientList extends Vue {

	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;
	@Stored(() => storeToken) token!: Token;

	private storeClient = storeClient;

	private url = process.env.VUE_APP_BACK_BASE_URL + '/api/clients'

	private editClient: Client = null;
	private deletedClient: Client = null;
	private dataGrid;

	private dataSource = createStore({
		key: 'id',
		loadUrl: `${this.url}/dxDataGrid`,
		onBeforeSend: (method, ajaxOptions) => {
			ajaxOptions.xhrFields = { withCredentials: true };
			ajaxOptions.headers = {
				'Authorization': 'BEARER ' + this.token.id
			}
		},
	});

	public refresh() {
		this.dataGrid = this.$refs['dataGridRefKey'] as DxDataGrid
		this.dataGrid.instance.refresh()
	}

	private fullAdresse(data) {
		if (data.address && data.zipCode && data.town) {
			return (data.address.trim()+' '+data.zipCode.trim()+' '+data.town.trim()).trim();
		} else if (data.address && data.zipCode && !data.town) {
			return (data.address.trim()+' '+data.zipCode.trim()).trim();
		} else if (data.address && !data.zipCode && data.town) {
			return (data.address.trim()+' '+data.town.trim()).trim();
		} else if (!data.address && data.zipCode && data.town) {
			return (data.zipCode.trim()+' '+data.town.trim()).trim();
		} else if (!data.address && !data.zipCode && data.town) {
			return data.town.trim();
		} else if (data.address && !data.zipCode && !data.town) {
			return data.address.trim();
		} else if (!data.address && data.zipCode && !data.town) {
			return data.zipCode.trim();
		} else {
			return '';
		}
	}

}
